import { Box, CircularProgress, Typography, Card } from "@mui/material";
import { useMaterialUIController } from "context";
import { useGetUserShiftDetailsMutation } from "features/geofenceSlice";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

const UserShiftDetails = ({ currentFolder, userShiftDetails }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  // useEffect(() => {
  //   // getUserShiftDetails(currentFolder?.name);

  //   fetchUserShiftDetails();
  // }, [currentFolder]);

  const columns = [
    {
      name: "S.NO.",
      selector: (row, index) => index + 1,
      sortable: true,
      center: true,
    },
    {
      name: "Shift Name",
      selector: (row) => row.shiftData?.name,
      sortable: false,
      left: true,
    },
    {
      name: "Shift Date",
      selector: (row) =>
        `${new Date(row.shiftData?.fromDate).toLocaleDateString()} - ${new Date(
          row.shiftData?.toDate
        ).toLocaleDateString()}`,
      sortable: false,
      center: true,
    },
    {
      name: "Shift Time",
      selector: (row) =>
        `${row.shiftData?.fromTime} - ${row.shiftData?.toTime}`,
      sortable: false,
      center: true,
    },
    {
      name: "Route name",
      selector: (row) => row.shiftData?.routeData?.name || "N/A",
      sortable: false,
      center: true,
    },
  ];

  return (
    <Box>
      <Typography variant="h6" sx={{ marginLeft: "1em" }}>
        {currentFolder?.name} Shift Details
      </Typography>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          // flexDirection: "column",
          // alignItems: "center",
          // justifyContent: "center",
          // color: darkMode ? "#fff" : "#000",
          borderRadius: 2,
        }}
      >
        {userShiftDetails.isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70vh",
              width: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : userShiftDetails.isError ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70vh",
              width: "100%",
            }}
          >
            <Typography variant="p">
              Something went wrong while getting the user shift details
            </Typography>
          </Box>
        ) : (
          <Card
            sx={{
              margin: ".5em",
              flexGrow: "1",
              flexBasis: "0",
              padding: ".5em",
              marginTop: "0.5em",
            }}
          >
            <DataTable
              columns={columns}
              data={userShiftDetails?.data || []}
              noDataComponent={
                <Typography
                  variant="p"
                  sx={{
                    textAlign: "center",
                    fontSize: "0.8em",
                    marginY: "1em",
                  }}
                >
                  This user doesn't have any shift details
                </Typography>
              }
              responsive
              pagination
              customStyles={{
                table: {
                  style: {
                    display: "block",
                  },
                },
                pagination: {
                  style: {
                    display: "flex",
                  },
                },
              }}
              paginationPerPage={10}
              striped
              theme={darkMode ? "modifiedDarkTheme" : "default"}
              defaultSortFieldId="id"
              paginationRowsPerPageOptions={[5, 10, 15, 20, 25]}
              fixedHeader
              fixedHeaderScrollHeight={"300px"}
              persistTableHead
            />
          </Card>
        )}
      </Box>
    </Box>
  );
};

export default UserShiftDetails;
